// Figuren-Outfits für Kapitel 4 (Palettenfarben aus art/palette.ts).
import { P } from '../art/palette.ts';
import type { Outfit } from './character.ts';

export const OUTFITS_CH4: Record<string, Outfit> = {
  // Hauke Dittmers, Wirt der „Goldenen Makrele“: goldgelbe Weste, Schiffermütze, gepflegter Bart
  dittmers: { coat: P.brass1, pants: P.night1, hair: P.wood3, skin: P.skin1, boots: P.wood0, hat: P.night1, beard: P.wood3 },
  // Fiete Lüders, Brakenhoffs Assistent: zu großer dunkler Anzug, rote Krawatte (Schal), blonder Scheitel
  fiete: { coat: P.night2, pants: P.night1, hair: P.amber2, skin: P.skin2, boots: P.ink, scarf: P.red2 },
  // Zollinspektorin Frauke Behrens: dunkelgrüne Uniform mit Dienstmütze
  zoellnerin: { coat: P.green1, pants: P.green0, hair: P.iron2, skin: P.skin2, boots: P.ink, hat: P.green0 },
  // Bootsbauer Ocke Petersen: Zimmermannskluft, Vollbart
  bootsbauer: { coat: P.wood3, pants: P.ink, hair: P.plaster2, skin: P.skin1, boots: P.wood1, beard: P.plaster2, scarf: P.red1 },
  // Fischfrau Wiebke: gelbes Ölzeug, Südwester
  fischfrau: { coat: P.amber1, pants: P.sea0, hair: P.red2, skin: P.skin2, boots: P.sea0, hat: P.amber1 },
};
